module.exports = __webpack_public_path__ + "img/SR.e2468314.svg";